import React from "react";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import { usePaymentAccount } from "./PaymentSetup.hooks";
import { PAGE_TITLE } from "./PaymentSetup.constants";
import { RootBox, PageTitle, LoadingBox } from "./PaymentSetup.styles";
import PaymentSetupAlerts from "./components/PaymentSetupAlerts";
import StripeConnectCard from "./components/StripeConnectCard";
import TierCard from "./components/TierCard";
import EarningsSummaryCard from "./components/EarningsSummaryCard";
import PayoutHistoryCard from "./components/PayoutHistoryCard";

const PaymentSetup = () => {
  const { userData, iphcPractitioner } = useSelector((state) => state.user);
  const isPractitioner =
    userData?.role !== "patient" &&
    iphcPractitioner &&
    Object.keys(iphcPractitioner).length > 0;

  const {
    loading,
    actionLoading,
    accountStatus,
    payoutSummary,
    supportedCountries,
    error,
    successMessage,
    pollingMessage,
    fetchAccountStatus,
    handleCreateAccount,
    handleContinueOnboarding,
    handleOpenDashboard,
    clearError,
    clearSuccess,
  } = usePaymentAccount();

  if (!isPractitioner) {
    return null;
  }

  if (loading) {
    return (
      <LoadingBox>
        <CircularProgress />
      </LoadingBox>
    );
  }

  return (
    <RootBox>
      <PageTitle variant="h5" gutterBottom>
        {PAGE_TITLE}
      </PageTitle>

      <PaymentSetupAlerts
        error={error}
        successMessage={successMessage}
        pollingMessage={pollingMessage}
        onCloseError={clearError}
        onCloseSuccess={clearSuccess}
      />

      <StripeConnectCard
        accountStatus={accountStatus}
        actionLoading={actionLoading}
        supportedCountries={supportedCountries}
        onRefresh={fetchAccountStatus}
        onCreateAccount={handleCreateAccount}
        onContinueOnboarding={handleContinueOnboarding}
        onOpenDashboard={handleOpenDashboard}
      />

      {accountStatus?.onboardingComplete && payoutSummary && (
        <>
          <TierCard currentTier={payoutSummary.currentTier} />
          <EarningsSummaryCard totals={payoutSummary.totals} />
          <PayoutHistoryCard transfers={payoutSummary.transfers} />
        </>
      )}
    </RootBox>
  );
};

export default PaymentSetup;
